import React, { useEffect, useState } from "react";
import Switch from '@mui/material/Switch';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Drawer, Typography } from "@mui/material";
import {
  cn,
  convertToJsonObject,
  filterKeys,
  getMinMaxOfData,
  getMinMaxOfMeasureMentData,
  getRatioMinMaxOfData,
  milkyValues,
  negativeKeyMap1,
  negativeFiltersList,
  negativeKeyMap,
} from "../../utils/utils";
import _ from "lodash";
import FilterMinMaxNew from "../filterMinMaxNew";
import TableFilterTop from "../TableFilter/TableFilterTop";
import amplitude from "../../utils/ampli";
import TableFilter2 from "../TableFilter/tableFilter2";
import { pricing, setFilteredRedux, setFilteredPerformanceRedux } from "../../redux/slices/pricingSlice";
import { useDispatch, useSelector } from "react-redux";
import HalfExpandedCard from "./halfExpandedCard";
import SaveSearchDropdown from "./saveSearchDropdown";

const PerformanceFilterDrawer = ({ open, onClose, data, filtered, setFiltered, sortState, setIsResetting, accountDetails,id }) => {
  // local state.
  const [filterState, setFilterState] = useState([]);
  const preDefinedSearchId = useSelector(pricing).preDefinedSearchId;
  const dispatch = useDispatch();
  const negativeKeyMapChoice = accountDetails == "1130" ? negativeKeyMap1 : negativeKeyMap;

  // we set the filter state to the filtered value, when the drawer is opened.
  // this is done so that the drawer shows the filtered values.
  useEffect(() => {
    if (open) {
      setFilterState(filtered);
    }
  }, [open, dispatch]);


//   const mFilters = [
//     {
//       label: "Length",
//       key: "Length",
//       min: 0,
//       max: 100,
//     },
//     {
//       label: "Width",
//       key: "Width",
//       min: 0,
//       max: 100,
//     },
//     {
//       label: "Depth",
//       key: "Depth",
//       min: 0,
//       max: 100,
//     },
//     {
//       label: "Ratio",
//       key: "Ratio",
//       min: 0,
//       max: 100,
//     },
//   ];

//   const mMFilters = [
//     {
//       label: "Table%",
//       key: "Table%",
//       min: 0,
//       max: 100,
//     },
//     {
//       label: "Depth%",
//       key: "Depth%",
//       min: 0,
//       max: 100,
//     },
//   ];
  
//   const newMFilters = [

//     {
//       label: "Rank",
//       key: "ld_analysis_hash.rap_rank",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Count",
//       key: "ld_analysis_hash.rap_matching_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Rank change",
//       key: "change_in_rap_rank",
//       min: -9999,
//       max: 9999,
//     },
//     {
//       label: "Count change",
//       key: "change_in_rap_count",
//       min: -9999,
//       max: 9999,
//     },
//     {
//       label: "Added",
//       key: "market_items_added_array_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Sold",
//       key: "market_items_sold_array_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Aging",
//       key: "attr_types.for_sale_from",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Broad Count",
//       key: "total_saved_prmi",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "My Stock",
//       key: "inventory_items_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "My Sales",
//       key: "sold_items_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "My YTD Sales",
//       key: "ytd_sales_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Added (30 D)",
//       key: "last_n_days_added_array_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Sold (30 D)",
//       key: "last_n_days_sold_array_count",
//       min: 0,
//       max: 9999,
//     },
//     {
//       label: "Rank Change (30 D)",
//       key: "last_n_days_rank_change",
//       min: -9999,
//       max: 9999,
//     },
//     {
//       label: "Count Change (30 D)",
//       key: "last_n_days_count_change",
//       min: -9999,
//       max: 9999,
//     },
//     // {
//     //   label: "Tracking Date",
//     //   key: "tracking_start_date",
//     //   min: 0,
//     //   max: 100,
//     // },
//   ];


  let negativeFilters = {};
  if(id === "market-intelligence"){
    negativeFilters = {
      // cut: "Cut",
      // polish: "Polish",
      // sym: "Symmetry",
      // flr: "Fluor",
      // lab: "Lab",
      // shade: "Shade",
      // milky: "Milky",
      // ld_diff: "LD Reco Confidence",
      locations: "Location",
      // repriced_filter_options: "Repriced Options",
    };
  }
  else{
     if(accountDetails == "552" ){
      negativeFilters = {
      cut: "Cut",
      polish: "Polish",
      sym: "Symmetry",
      flr: "Fluor",
      lab: "Lab",
      // shade: "Shade",
      // milky: "Milky",
      // ld_diff: "LD Reco Confidence",
      locations: "Location",
      cities: "City",
      // repriced_filter_options: "Repriced Options",
    }
    
     }
     else if(accountDetails == "1130"){
        negativeFilters = {
          cut: "Cut",
          polish: "Polish",
          sym: "Symmetry",
          flr: "Fluor",
          labbased: "Lab",
          // lab: "Lab",
          // shade: "Shade",
          // milky: "Milky",
          // ld_diff: "LD Reco Confidence",
          locations: "Location",
          cities: "City",
          
          // repriced_filter_options: "Repriced Options",
    }
     }
     else{
      negativeFilters = {
      cut: "Cut",
      polish: "Polish",
      sym: "Symmetry",
      flr: "Fluor",
      lab: "Lab",
      // shade: "Shade",
      // milky: "Milky",
      // ld_diff: "LD Reco Confidence",
      locations: "Location",
      // cities: "City",
      // repriced_filter_options: "Repriced Options",
    };
     }
    
    
  }

  const expandableKeys =
  accountDetails === "1130"
    ? ["labbased", "shade", "locations"]
    : ["lab", "shade", "locations"];
//   const marketFilters = newMFilters.filter(filter => 
//     !['inventory_items_count', 'sold_items_count', 'attr_types.for_sale_from', 'ytd_sales_count'].includes(filter.key)
//   );

//   const inventoryFilters = newMFilters.filter(filter => 
//     ['inventory_items_count', 'sold_items_count', 'attr_types.for_sale_from', 'ytd_sales_count'].includes(filter.key)
//   );

  const handleMeasurement = (key, value) => {
    setFilterState((prev) => {
      let x = [...prev];
      // we find if the prev state has any obj with id of key
      // it basically checks if the obj exist if yes then we
      // only update the values, if not then create and push the object.
      let obj = x.find((obj) => obj.id === "Measurements");
      
      // if there is no object, or if length of filtered is zero(means 1st filter is being applied)
      // then we create and push a new object to array
      
      if (!obj || x.length == 0) {
        x.push({
          id: "Measurements",
          value: {
            [key]: value,
          },
        });
      } else {
        // if the item exist, then we map through the obj to get the item and update its value.
        // TODO: need to optimize this bit as we loop twice for obj and then for this block.
        x.map((item) => {
          if (item.id == "Measurements") {
            let val = item.value;
            item.value = {
              ...val,
              [key]: value,
            };
          }
        });
      }
      return x; // return the new state array
    });
  };

  const handleSetFilter = (key, value) => {
    // console.log({
    //   filterState,
    // });
    // we the key, for which the value is being filtered.

    // we set the filtered value.
    setFilterState((prev) => {
      let x = [...prev];

      // we find if the prev state has any obj with id of key
      // it basically checks if the obj exist if yes then we
      // only update the values, if not then create and push the object.

      let obj = x.find((obj) => obj.id === key);
      
      // if there is no object, or if length of filtered is zero(means 1st filter is being applied)
      // then we create and push a new object to array

      if (!obj || x.length == 0) {
        if (negativeFiltersList.includes(key)) {
          let a = filterKeys[negativeKeyMapChoice[key]].filter(
            (item) => !value.includes(item)
          );

          x.push({
            id: key,
            value: a,
          });
        } else {
          x.push({
            id: key,
            value: value,
          });
        }
      } else {
        // if the item exist, then we map through the obj to get the item and update its value.
        // TODO: need to optimize this bit as we loop twice for obj and then for this block.

        if (value.length == 0) {
          x = x.filter((item) => item.id !== key);
        } else {
          if (negativeFiltersList.includes(key)) {
            let a = filterKeys[negativeKeyMapChoice[key]].filter((item) => !value.includes(item));
            x = x.map((item) => item.id === key ? { ...item, value: a } : item);
        } else {
            x = x.map((item) => item.id === key ? { ...item, value } : item);
        }
        }
      }

      return x; // return the new state array
    });
  };

  function getObjectById(array, id) {
    let x = array.find((obj) => obj.id === id);
    return x || { id, value: [] };
  }

  return (
    <Drawer anchor={"right"} open={open} onClose={onClose}>
      {/* {console.log({
        filterState,
        filtered,
        a: convertToJsonObject(filterState),
      })} */}
      <div className="w-[90vw] min-w-[400px] md:w-[30vw] md:min-w-[450px] md:max-w-[450px] min-h-full h-[full] flex flex-col overflow-hidden">
        <header className="min-h-[60px] border-x-0  border-t-0 border-b border-solid border-[#D8D8D8] flex items-center gap-4">
          <svg
            className="ml-4 cursor-pointer"
            xmlns="http://www.w3.org/2000/svg"
            width="15px"
            height="15px"
            viewBox="0 -2 32 32"
            onClick={onClose}
          >
            <g id="Lager_86" data-name="Lager 86" transform="translate(0 -3)">
              <path
                id="Path_94"
                data-name="Path 94"
                d="M16.587,6.42,27.167,17,16.587,27.58a2,2,0,0,0,2.833,2.833L31.414,18.42a2.013,2.013,0,0,0,0-2.84L19.42,3.587A2,2,0,0,0,16.587,6.42Z"
                fill="#161615"
              />
              <path
                id="Rectangle_45"
                data-name="Rectangle 45"
                d="M0,0H26a2,2,0,0,1,2,2V2a2,2,0,0,1-2,2H0A0,0,0,0,1,0,4V0A0,0,0,0,1,0,0Z"
                transform="translate(28 19) rotate(180)"
                fill="#161615"
              />
            </g>
          </svg>
          <h4 className="m-0 font-medium text-base">Filter Options.</h4>
        </header>

        <div className="overflow-auto h-full ">
          {/* <div className="flex flex-col px-3 py-3 gap-2">
            <h6 className="my-0 px-2 mb-2 m-0 font-bold text-xs text-[#838383]">DIMENSIONS</h6>
            <div className="grid grid-col-1 gap-2">
              {mFilters.map((item) => {
                let obj = filtered.find((obj) => obj.id === item.label);

                return (
                  <FilterMinMaxNew
                    label={item.label}
                    setFiltered={handleSetFilter}
                    filtered={obj ? obj.value : null}
                    dMin={item.min}
                    dMax={item.max}
                    val={item.key}
                  />
                );
              })}
            </div>
          </div>
          <div className="h-[1px] w-[90%] border-x-0  border-t border-b-0 border-solid border-[#D8D8D8] m-auto" />
          <div className="flex flex-col px-3 py-3 gap-2">
            <h6 className="my-0 px-2 mb-2 m-0 font-bold text-xs text-[#838383]">
              PROPORTIONS
            </h6>
            <div className="grid grid-col-1 gap-2">
              {mMFilters.map((item) => {
                let obj = filtered.find((obj) => obj.id === item.key);

                return (
                  <FilterMinMaxNew
                    label={item.label}
                    setFiltered={handleSetFilter}
                    filtered={obj ? obj.value : null}
                    dMin={item.min}
                    dMax={item.max}
                    val={item.key}
                  />
                );
              })}
            </div>
          </div> */}
          <div className="h-[1px] w-[90%] border-x-0  border-t-0 border-b-0 border-solid border-[#D8D8D8] m-auto" />
          
          {Object.entries(negativeFilters).map(([key, value]) => {
            if (expandableKeys.includes(key.toLowerCase())) {
              return (
                <HalfExpandedCard value={["shape"].includes(key.toLowerCase()) } value1={["lab"].includes(key.toLowerCase()) }>
                  <>
                    {/* looping through all the filters */}
                    <div className="flex flex-col px-3  gap-2">
                      {/* <h6 className="m-0 font-bold text-xs text-[#838383]">LOCATION</h6> */}
                      <TableFilter2
                        data={filterKeys[key]}
                        label={value}
                        filtered={
                          filterState.length > 0
                            ? getObjectById(filterState, value)
                            : { id: value, value: [] }
                        }
                        setFiltered={handleSetFilter}
                      />
                    </div>
                  </>
                </HalfExpandedCard>
              );
            } else {
              return (
                <>
                  {/* looping through all the filters */}
                  <div className="flex flex-col px-3  gap-2">
                    {/* <h6 className="m-0 font-bold text-xs text-[#838383]">LOCATION</h6> */}
                    <TableFilter2
                      data={filterKeys[key]}
                      label={value}
                      filtered={
                        filterState.length > 0
                          ? getObjectById(filterState, value)
                          : { id: value, value: [] }
                      }
                      setFiltered={handleSetFilter}
                    />
                  </div>
                </>
              );
            }
          })}
          {/* <HalfExpandedCard>
          <div className="flex flex-col px-3  gap-2">
            <TableFilterTop
              data={filterKeys.ktsCount}
              label="KEY TO SYMBOLS"
              filtered={
                filterState.length > 0
                  ? getObjectById(filterState, "Key To Symbol")
                  : { id: "Key To Symbol", value: [] }
              }
              setFiltered={handleSetFilter}
            />
          </div>
            </HalfExpandedCard> */}
          <div className="h-[1px] w-[90%] border-x-0  border-t-0 border-b border-solid border-[#D8D8D8] m-auto" />
          {/* <div className="flex flex-col px-3 py-3 gap-2">
            <h6 className="my-0 px-2 mb-2 m-0 font-bold text-xs text-[#838383]">
              INVENTORY
            </h6>
            <div className="grid grid-col-1 gap-2">
              {inventoryFilters.map((item) => {
                let obj = filtered.find((obj) => obj.id === item.key);

                return (
                  <FilterMinMaxNew
                    label={item.label}
                    setFiltered={handleSetFilter}
                    filtered={obj ? obj.value : null}
                    dMin={item.min}
                    dMax={item.max}
                    val={item.key}
                  />
                );
              })}
            </div>
          </div> */}
          <div className="h-[1px] w-[90%] border-x-0  border-t-0 border-b border-solid border-[#D8D8D8] m-auto" />
          {/* <HalfExpandedCard market={true}>
          <div className="flex flex-col px-3 py-3 gap-2">
            <h6 className="my-0 px-2 mb-2 m-0 font-bold text-xs text-[#838383]">
              MARKET
            </h6>
            <div className="grid grid-col-1 gap-2">
              {marketFilters.map((item) => {
                let obj = filtered.find((obj) => obj.id === item.key);

                return (
                  <FilterMinMaxNew
                    label={item.label}
                    setFiltered={handleSetFilter}
                    filtered={obj ? obj.value : null}
                    dMin={item.min}
                    dMax={item.max}
                    val={item.key}
                  />
                );
              })}
            </div>
          </div>
          </HalfExpandedCard> */}
          
        </div>

        <div className="min-h-12 w-full  bg-white  border-x-0  border-t border-b-0 border-solid border-[#D8D8D8] flex items-center justify-evenly gap-4 px-4 py-2">
          <button
            className={cn(
              "h-8 max-w-[180px] w-full border-none rounded-xl cursor-pointer text-sm font-medium",
              filterState !== filtered 
                ? "bg-[#A4D9FF]"
                : "bg-gray-200 text-gray-400"
            )}
            onClick={(e) => {
              // amplitude events.
              const buttonClickedEvent = {
                event_type: `v3_stock_performance_filter`,
                value: filterState,
              };
              amplitude.track(buttonClickedEvent);
              setIsResetting(false);
              dispatch(setFilteredPerformanceRedux(filterState));
              setFiltered(filterState);
              onClose(e);
            }}
          >
            Apply
          </button>
          
          <button className="h-8 max-w-[180px] w-full bg-white border-[#EAEAEA] border-solid outline-none rounded-xl text-sm font-medium"
            onClick={(e) => {
                const buttonClickedEvent = {
                  event_type: `v3_stock_performance_reset`,
                  value: filterState,
                };
                amplitude.track(buttonClickedEvent);
                dispatch(setFilteredPerformanceRedux([]));
                setFilterState([]);
                setFiltered([]);
                setIsResetting(true);
                onClose(e);
            }}>Reset
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default PerformanceFilterDrawer;